import PropTypes from 'prop-types';
import React from 'react';
import { SHOPPING_CATEGORY_COLLECTIONS } from '../../../constants';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import classNames from 'classnames';

const getTagline = (categoryType) => {
  if (categoryType === SHOPPING_CATEGORY_COLLECTIONS) {
    return (
      <RosettaFormattedMessage parentFilename={__filename}
        id="browsing_collections"
        description="Message above collections title on header image"
        defaultMessage="Browsing Collections"
      />
    );
  }

  return (
    <RosettaFormattedMessage parentFilename={__filename}
      id="browsing"
      description="Message above category title on header image"
      defaultMessage="Browsing"
    />
  );
};

const getFeaturedCollectionName = (featuredCollectionName) => (
  <div className="subtitle-wrapper">
    <RosettaFormattedMessage parentFilename={__filename}
      id="featured_collection"
      description="Message above category subtitle on header image"
      defaultMessage="Featured Collection"
    />
    <h2 dangerouslySetInnerHTML={{ __html: featuredCollectionName }} />
  </div>
);

export const ProductListHeroContent = ({ pageTitle, logoImage, categoryType, featuredCollectionName }) => (
  <div className=
    {classNames('title-wrapper', { 'title-collections': categoryType === SHOPPING_CATEGORY_COLLECTIONS })}
  >
    <div className="content">
      <div className="tagline">
        {!featuredCollectionName && getTagline(categoryType)}
      </div>
      {!logoImage && <h1 dangerouslySetInnerHTML={{ __html: pageTitle }} />}
      {logoImage && <img className="logo-image" src={logoImage} />}
      {featuredCollectionName && getFeaturedCollectionName(featuredCollectionName)}
    </div>
  </div>
);

ProductListHeroContent.propTypes = {
  pageTitle: PropTypes.string,
  logoImage: PropTypes.string,
  categoryType: PropTypes.string,
  featuredCollectionName: PropTypes.string
};

export default ProductListHeroContent;
